document.addEventListener("DOMContentLoaded", function () {
    /** Get the list container and slider container */
    const itemList = document.getElementById('item-list');
    const sliderContainer = document.querySelector('.slider');

    /** Check if the elements exist */
    if (!itemList || !sliderContainer) {
        console.log('Error: list or slider container is missing.');
        return;
    }

    /** Get all list items from the unordered list */
    const items = itemList.querySelectorAll('.list-item');

    /** Check if list items exist */
    if (items.length === 0) {
        console.log('No items found in the list!');
        return;
    }

    /** Populate the slider with list items */
    items.forEach((item) => {
        const sliderItem = document.createElement('div');
        sliderItem.classList.add('slider-item');
        sliderItem.innerHTML = item.innerHTML; /** Copy content of the list item */
        sliderContainer.appendChild(sliderItem);
    });

    /** Get all newly created slider items */
    const sliderItems = sliderContainer.querySelectorAll('.slider-item');

    /** If no slider items exist, exit */
    if (sliderItems.length === 0) {
        console.log('Slider items were not created properly.');
        return;
    }

    /** Initialize slider index */
    let currentIndex = 0;
    
    /** Function to show the current slider item */
    function showNextItem() {
        /** Hide the current item by moving it to the left and fading out */
        sliderItems[currentIndex].classList.remove('active');
        sliderItems[currentIndex].style.opacity = '0';
        sliderItems[currentIndex].style.transform = 'translateX(-100%)';

        /** Increment index and loop back if at the end */
        currentIndex = (currentIndex + 1) % sliderItems.length;

        /** Reset the next item off-screen to the right */
        sliderItems[currentIndex].style.display = 'block';
        sliderItems[currentIndex].style.transform = 'translateX(100%)';
        sliderItems[currentIndex].style.opacity = '0';

        /** Allow a slight delay before triggering the transition */
        setTimeout(() => {
            sliderItems[currentIndex].classList.add('active');
            sliderItems[currentIndex].style.transform = 'translateX(0)';
            sliderItems[currentIndex].style.opacity = '1';
        }, 50);
    }

    /** Show the first item */
    sliderItems[currentIndex].style.display = 'block';
    sliderItems[currentIndex].classList.add('active');
    sliderItems[currentIndex].style.opacity = '1';
    sliderItems[currentIndex].style.transform = 'translateX(0)';

    /** Set interval to change the item every 3 seconds */
    setInterval(showNextItem, 3000);
});